import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {TollPoliciesContent} from "./tollPolicies.jsx";

export function CostCalculation({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep="selectedCarDetails" showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            {/* "Toll hwy and other costs may apply" opens this popup → show the policy. */}
            <TollPoliciesContent/>
        </>
    );
}
export default CostCalculation;
